import { Checkbox, Group } from '@mantine/core'
import type { FC } from 'react'

type CustomCheckboxProps = {
  name: string
  title: string
  description: string | null
  options: string[]
  error: string | undefined
}

export const CustomCheckbox: FC<CustomCheckboxProps> = ({
  name,
  title,
  description,
  options,
  error,
}) => {
  return (
    <Checkbox.Group label={title} description={description} error={error}>
      <Group mt='xs'>
        {options.map((val) => (
          <Checkbox name={name} key={val} value={val} label={val} />
        ))}
      </Group>
    </Checkbox.Group>
  )
}
